import React, { useState, useEffect } from 'react';
import DataGrid, {
    Column, Editing, Paging, Pager, SearchPanel
} from 'devextreme-react/data-grid';
import './serviceStatus.css'
import { useDispatch,useSelector } from 'react-redux'
import axiosConfig from '../../configs/axios.config';
import axios from 'axios'
import { AccessRolesSelector } from '../../store/reducers/permistion';
import Utils from '../../utils';
import { MODULES, ACTION } from '../../configs/namePermission';

const pageSizes = [25, 50, 100];
const ListInventoryBarcode = () => {
    const dispatch = useDispatch()
    const [loadData, setLoadData] = useState()
    const AccessSelector = useSelector(AccessRolesSelector)

    useEffect(() => {
        const fetchData = async () => {
            const response = await axios.create(axiosConfig).get('api/inventory/GetBarCodeImport')
            setLoadData(response.data.result)
        }
        fetchData()
    }, [])

    const onRowUpdated = async (value) => {
        await axios.create(axiosConfig).post('api/inventory/UpdateInventoryImport', value.data)
    };

    const onRowRemoved = async (value) => {
        await axios.create(axiosConfig).post('api/inventory/DelInventoryImport', value.data)
    };

    const onRowInserted = async (value) => {
        await axios.create(axiosConfig).post('api/ServicesIT/PostInsertServicesIT', value.data)
        const response = await axios.create(axiosConfig).get('api/ServicesIT/GetServicesIT')
        setLoadData(response.data.result)
    };

    // const onRowPrepared = (rowElement) => {
    //     if (rowElement.rowType === 'data' && rowElement.data) {
    //         if (rowElement.data.RemainingDay < 91 && rowElement.data.RemainingDay > 30)
    //             rowElement.rowElement.bgColor = "#FEE9CE";
    //         else if (rowElement.data.RemainingDay < 31)
    //             rowElement.rowElement.bgColor = "#F5C691";
    //     }

    // };


    return (
        <>
            <h1 >danh sách barcode Nhập kho</h1>
            <React.Fragment>
                <DataGrid
                    id="gridContainer"
                    dataSource={loadData}
                    keyExpr="Id"
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    showBorders={true}
                    showRowLines={true}

                    // onRowPrepared={onRowPrepared}
                    // onRowInserted={onRowInserted}
                    onRowUpdated={onRowUpdated}
                    onRowRemoved={onRowRemoved}>
                    <SearchPanel visible={true} highlightCaseSensitive={true} width={1500} />
                    <Paging enabled={true} />
                    <Editing
                        mode="row"
                        allowUpdating={Utils.checkPermistion(AccessSelector, MODULES?.LIST_IMPORT, ACTION?.UPDATE )}
                        allowDeleting={Utils.checkPermistion(AccessSelector, MODULES?.LIST_IMPORT, ACTION?.DELETE )}
                        allowAdding={false} />

                    <Column dataField="Id" caption="ID" allowEditing={false} width={50} />
                    <Column dataField="ItemCode" caption={"Mã hàng"} />
                    <Column dataField="NewItemCode" caption={"mã hàng mới"} />
                    <Column dataField="BarCode" caption={"BarCode"} width={550} />
                    <Column dataField="Qty" caption={"Số lượng"} format={"###,###,###.####"} />
                    <Column dataField="Note" caption={"Ghi chú"} />
                    <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                    <Paging defaultPageSize={25} />
                </DataGrid>


            </React.Fragment>
        </>
    );
};



export default ListInventoryBarcode;